import React, { useCallback, useState } from "react";
import { FieldRendererProps, FieldTableRendererCallback, FieldTableRowProps, IdedType } from "./FieldTableTypes";
import { getObjectByPath } from '../../utils';
import {Collapse, IconButton, styled} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';


const baseEditor: FieldTableRendererCallback<any,null> = ({ field }) => <input {...field} />;

const baseRenderer: FieldTableRendererCallback<any,null> = ({ field }) => {
    if (field.value) return field.value;
    // eslint-disable-next-line react/prop-types
    if (field.value === 0 || field.value === '' || field.value === '0') return field.value;
    return '';
};

type FieldTableCellProps = {
    hasError?: any,
    isEditing?: boolean
};

const FieldTableCell = styled('div', {
    name: 'FieldTable', slot: 'cell',
    shouldForwardProp: (prop) =>
        prop !== 'variant' && prop !== 'sx',
    overridesResolver: (props, styles) => [
        styles.cell,
        props.hasError && styles.cellError
    ],
})<FieldTableCellProps>({});


// eslint-disable-next-line react/display-name
export function FieldRow<Type extends IdedType,RowPropsType>(props: FieldTableRowProps<Type,RowPropsType>) {
    //const currency = React.useContext(CurrencyContext)?.defaultCurrency;
    const [editingAccessor, setEditingAccessor] = useState('');
    const ocr = props.onChangeRowFocus;
    const onFocus = useCallback((column, args?) => () => {
        if(ocr) {
            ocr(''+props.rowData?.id);
        }
        if (column.onFocus) {
            column.onFocus(args);
        }
        setEditingAccessor(column.accessor);
    }, [ocr, props.rowData?.id, setEditingAccessor]);
    const toggleOpen = useCallback(() => {
        console.log('TOGGLE OPEN',props.rowData);
        if(props.toggleOpen) {
            props.toggleOpen(''+props.rowData?.id);
        }
    }, []);
    const toggleExclusion = useCallback(() => {
        props.excludeId(''+props.rowData?.id);
    }, []);

    const toggleSelected = useCallback(() => {
        console.log('toggleselected on',props.rowData?.id);
        if(props.toggleSelected) {
            props.toggleSelected(''+props.rowData?.id);
        }
    }, []);
    const row = props.columns.map((column) => {
        if (column.exportOnly) return;
        if(column.hideWhen) {
            if(column.hideWhen({exchangeRateContext:props.exchangeRate})) {
                return;
            }
        }
        if (props.loading) {
            return <span key={column.accessor} tabIndex={-1} className={(column.className ? column.className : '') + ' field-table__cell'}><span className="bp3-skeleton"></span></span>;
        }
        const className = ' ' + (column.className ? column.className : '');
        let isEditing = false;
        if (column.editor && props.isEditingRow && editingAccessor === column.accessor) {
            isEditing = true;
        }
        if(props.readOnly) {
            isEditing = false;
        }
//        if(column.dataType && props.columnTypesContext.register[column.dataType]) {
            const columnDef = props.columnTypesContext.register[column.dataType]??props.columnTypesContext.register['default'];
            const hasError = (props.rowErrors && (props.rowErrors[column.accessor] || (column.sort && props.rowErrors[column.sort])));

/*            let fieldCurrency = null;
            if(column.currencyAccessor && column.currencyAccessor!='none') {
                fieldCurrency = getObjectByPath(props.rowData,column.currencyAccessor);
            }*/
            console.log('TSR',props.exchangeRate);
            const ftProps: FieldRendererProps<Type,RowPropsType> = {
                field: {
                    name: props.name + '.' + column.accessor,
                    value: getObjectByPath(props.rowData, column.accessor),
                    onChange: (v)=>{ if(column.filterValue) { v.target.value = column.filterValue(v.target.value); } props.onChange(v) },
                    fill: true,
                    readOnly: props.readOnly,
                    setValue: props.setValue,
                    variant: 'standard',
                    fullWidth: true,
                    error: hasError
                },
                dataType:column.dataType,
                options: column.options,
                currencyAccessor: column.currencyAccessor,
                row: props.rowData,
                rowName: props.name,
                rowProps: props.rowProps,
                columnData:column.data,
                nullRenderAs:column.nullRenderAs,
                setValue:props.setValue,
                toggleExclusion:toggleExclusion,
                calcExchangeRate: props.exchangeRate.calcExchangeRate,
                isRowOpen:props.isRowOpen,
                toggleOpen:toggleOpen,
                toggleSelected:toggleSelected,
                isSelected:props.isSelected,
                defaultCurrency: props.exchangeRate?.targetCurrency
            };
            /*if (hasError) {
                ftProps.intent = 'danger';
            }*/
            let content = null;
            let readOnly = props.readOnly || !columnDef.renderEditor;
            if(!readOnly) {
                if(typeof column.readOnly == 'function') {
                    console.log('docheckreadonlycheck',column.readOnly(ftProps));
                    readOnly = column.readOnly(ftProps);
                } else {
                    readOnly = !!column.readOnly;
                }
            }
            isEditing = (!readOnly && (columnDef.renderEditor||column.options.renderEditor) && props.isEditingRow && editingAccessor === column.accessor);
            const columnDefRenderer = isEditing ? columnDef.renderEditor:columnDef.renderViewer;
            const columnRenderer = isEditing ?column.options?.renderEditor:column.options?.renderViewer;
            if(columnRenderer) {
                content = columnRenderer(ftProps);
            }
            if(content===null && columnDefRenderer) {
                content = columnDefRenderer(ftProps);
            }
            if(content===null && !columnDefRenderer) {
                console.log(isEditing,column,columnDef,columnDefRenderer,columnDef.renderEditor,columnDef.renderViewer);
            }
            return (<FieldTableCell hasError={hasError} isEditing={!readOnly && isEditing} tabIndex={!readOnly && !isEditing ? 0 : -1} key={column.accessor}
                className={['field-table__cell',columnDef.className(),column.className??'',isEditing ?'editing':'',hasError?'error':''].join(' ')}
                onFocus={onFocus(column)}>
                {content}
            </FieldTableCell>);
        
//        }

        switch (true) {
            /*case column.expander:
                className += ' column-expander';
                return <div tabIndex={-1} key={column.accessor}
                    className={'field-table__cell ' + (className ? className : '')}>
                    <div onClick={toggleOpen} className="column-expander__inner">
                        <Button intent="primary" small={true} className={(props.isRowOpen ? ' rotate-90' : '')}
                            icon="caret-right" minimal={false} />
                        {/*<Icon intent="primary" className={(props.isRowOpen ? ' rotate-90' : '')}
                         icon="caret-right"  />}</div></div>;*/
                         /*
            case column.selector:
                className += ' column-expander';
                return <div tabIndex={-1} key={column.accessor}
                    className={'field-table__cell column-select'}
                ><Button small={true} className="uneditable" icon={props.isSelected ? 'tick' : 'blank'} onClick={toggleSelected} /></div>;
                */
            /*case column.excluder:
                className += ' column-expander';
                return <div tabIndex={-1} key={column.accessor}
                className={'field-table__cell column-expander'}
                ><Button small={true} className="uneditable" icon="ban-circle" onClick={toggleExclusion} /></div>;*/
            default:
                const hasError = (props.rowErrors && (props.rowErrors[column.accessor] || (column.sort && props.rowErrors[column.sort])));

                const renderer = isEditing ? (column.editor ? column.editor : baseEditor) :
                    (column.renderer ? column.renderer : baseRenderer);
                    let fieldCurrency = null;
                    if(column.currencyAccessor && column.currencyAccessor!='none') {
                        fieldCurrency = getObjectByPath(props.rowData,column.currencyAccessor);
                    }
                    const ftProps: FieldRendererProps<Type,RowPropsType> = {
                    field: {
                        name: props.name + '.' + column.accessor,
                        ...column.fieldProps,
                        value: getObjectByPath(props.rowData, column.accessor),
                        onChange: props.onChange,
                        fill: true,
                        readOnly: props.readOnly,
                        setValue: props.setValue,
                        error: hasError,
                        currency: fieldCurrency?fieldCurrency:(props.exchangeRate?.targetCurrency)
                    }, 
                    row: props.rowData, 
                    rowName: props.name, 
                    rowProps: props.rowProps,
                    columnData:column.data,
                    setValue:props.setValue,
                    isSelected:props.isSelected,
                    toggleSelected:props.toggleSelected,
                    toggleExclusion:toggleExclusion,
                    calcExchangeRate: props.exchangeRate.calcExchangeRate
                };

                return (<div tabIndex={column.editor && !isEditing ? 0 : -1} key={column.accessor}
                    className={'field-table__cell' + (className ? className : '') + (isEditing ? ' editing' : (hasError ? ' error' : ''))}
                    onFocus={onFocus(column)}>
                    {/*renderer(ftProps)*/}
                </div>);
        }
    });
    if (props.hasDelete) {
        row.push(<div tabIndex={-1} key={'_delete'}
            className={'field-table__cell column-delete'}>
            {!props.readOnly && !props.noResults && <IconButton size="small" tabIndex={-1} className={props.loading ? 'bp3-skeleton' : ''} onClick={props.deleteRowById}><DeleteIcon/></IconButton>}
        </div>);
    }
    const result = <div key={'' + props.rowData.id} data-id={props.rowData.id}
        className={'field-table__row ' + (props.className ? props.className : '')+(props.getRowClass?' '+props.getRowClass(props.rowData):'')}>{row}</div>;
    if (!props.children) return result;
    return (
        <React.Fragment>
            {result}
            <Collapse className="field-table__span field-table__child" in={props.isRowOpen}>
                {props.children({ name: props.name, row: props.rowData })}
            </Collapse>
        </React.Fragment>
    );
}
